<template>
  <div class="more-offers-loader" v-if="offersToLoad > 0">
    <a href="#" class="more-offers-loader__link" @click.prevent="$emit('load')">
      Pokaż więcej ofert ({{ offersToLoad }})
    </a>
    <Icon icon="arr-right" class="more-offers-loader__arrow" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'

@Component({
  components: {
    Icon,
  },
  props: {
    offersToLoad: {
      required: true,
      type: Number,
    },
  },
})
export default class MoreOffersLoader extends Vue {
}
</script>

<style lang="scss">
.more-offers-loader {
  background-color: #eee;
  padding: 8px 0;
  width: 100%;
  text-align: center;
  display: flex;

  &__link {
    padding: 10px 20px;
    text-decoration: none;
    margin-left: auto;
    color: #005ca9;
    line-height: 1;
    outline: none;

    &:hover {
      text-decoration: underline;
      color: #005ca9;
    }
  }

  &__arrow {
    color: #005ca9;    
    margin-top: 10px;
    margin-right: auto;
    margin-left: -8px;
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/MoreOffersLoader.vue